import React from "react";
import { ProductName } from "types/general";
import * as Styled from "./styled";

const mapPartnerToLabel = (productName: ProductName) => {
  switch (productName) {
    case ProductName.taxRefundAdvance:
      return "Tax";
    default:
      return "EWA";
  }
};

interface Props {
  productName: ProductName;
}

const ProductTag: React.FC<Props> = ({ productName }) => {
  // For now we don't need additional noise for regular EWA onboarding
  if (productName !== ProductName.taxRefundAdvance) return null;

  return (
    <Styled.Wrapper $productName={productName}>
      {mapPartnerToLabel(productName)}
    </Styled.Wrapper>
  );
};

export default ProductTag;
